import { render, staticRenderFns } from "./text-row-bfb.vue?vue&type=template&id=458c38a1&scoped=true&"
import script from "./text-row-bfb.vue?vue&type=script&lang=js&"
export * from "./text-row-bfb.vue?vue&type=script&lang=js&"
import style0 from "./text-row-bfb.vue?vue&type=style&index=0&id=458c38a1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458c38a1",
  null
  
)

export default component.exports